// import axios from "axios"
import axios from "../../../constants/axios"

import { formatDateToBackend } from "../../../utils/format-date-time"

import endpoints from "../../../constants/endpoints"

export const CANDIDATE_EDUCATION_DATA_FETCH = async (
  id,
  dispatch,
  setEducation,
  setImages,
  setLoading
) => {
  try {
    const response = await axios.get(
      `${process.env.GATSBY_BASE_URL}/api/candidate/get-profile/${id}/`
    )
    const { data } = response

    const education_data = [...data.education]

    const training_data = [...data.certificates]

    setEducation(education_data)
    setImages(training_data)

    setLoading(false)

    return null
  } catch (err) {
    // dispatch({ type: "LOGOUT" })
    setLoading(false)
    return err
  }
}

export const EDUCATION_FORM_SUBMIT = async (
  educationFormData,
  setError,
  id,
  setAddEducation,
  setIsLoading
) => {
  const fd = new FormData()
  fd.append("college", educationFormData.companyName)
  fd.append("description", educationFormData.description)
  fd.append("degree", educationFormData.degreeName)
  fd.append("degreetype_id", educationFormData.degreetype)
  fd.append("candidate_id", id)
  fd.append("is_active", true)
  if (educationFormData.to) {
    fd.append("to_year", formatDateToBackend(educationFormData.to))
  }
  if (educationFormData.from) {
    fd.append("from_year", formatDateToBackend(educationFormData.from))
  }

  try {
    if (educationFormData.type === "PATCH") {
      await axios.patch(
        process.env.GATSBY_BASE_URL +
          endpoints.CANDIDATE_EDUCATION_SUBMIT +
          educationFormData.id +
          "/",
        fd,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
    } else {
      await axios.post(
        process.env.GATSBY_BASE_URL + endpoints.CANDIDATE_EDUCATION_SUBMIT,
        fd,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
    }
    setIsLoading(false)
    setAddEducation(false)
  } catch (error) {
    setError(error.response.data)
    setIsLoading(false)
  }
}

export const EDUCATION_FORM_DELETE = async (id, setShowDeleteForm) => {
  try {
    await axios.delete(
      process.env.GATSBY_BASE_URL +
        endpoints.CANDIDATE_EDUCATION_SUBMIT +
        id +
        "/"
    )
    setShowDeleteForm(false)
  } catch (err) {}
}

export const TRAINING_FORM_SUBMIT = async (
  trainingFormData,
  setError,
  id,
  setAddPortfolio,
  image_field,
  setIsLoading
) => {
  const fd = new FormData()
  fd.append("title", trainingFormData.title)
  fd.append("description", trainingFormData.description)
  fd.append("candidate_id", id)
  if (image_field !== undefined) {
    fd.append("image", image_field, image_field.name)
  }

  try {
    if (trainingFormData.type === "PATCH") {
      await axios.patch(
        process.env.GATSBY_BASE_URL +
          endpoints.CANDIDATE_TRAINING_SUBMIT +
          trainingFormData.id +
          "/",
        fd,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
    } else {
      await axios.post(
        process.env.GATSBY_BASE_URL + endpoints.CANDIDATE_TRAINING_SUBMIT,
        fd,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
    }
    setIsLoading(false)
    setAddPortfolio(false)
  } catch (error) {
    setError(error.response.data)
    setIsLoading(false)
  }
}

export const TRAINING_FORM_DELETE = async (id, setShowDeleteForm) => {
  try {
    await axios.delete(
      process.env.GATSBY_BASE_URL +
        endpoints.CANDIDATE_TRAINING_SUBMIT +
        id +
        "/"
    )
    setShowDeleteForm(false)
  } catch (err) {}
}
